<div class="_form-communication-component">
	<p [translate]="'COMMUNICATION.TITLE'"></p>
	<div class="_communication-endpoint" *ngFor="let item of communication">
		<ion-checkbox color="success" [formControl]="item.control"></ion-checkbox>
		<ion-label>{{item.label}}</ion-label>
	</div>

	<div class="_reply-to" *ngIf="replyTo">
		<p class="_reply-to-title" [translate]="'COMMUNICATION.REPLY_TO_TITLE'"></p>
		<p class="_subtitle" [translate]="'COMMUNICATION.REPLY_TO_SUBTITLE'"></p>

		<form-input label="{{ 'COMMUNICATION.REPLY_TO' | translate }}" [formControl]="replyTo | cast"></form-input>
		<form-input *ngIf="telephone" label="{{ 'COMMUNICATION.TELEPHONE' | translate }}" [formControl]="telephone | cast"></form-input>
	</div>
</div>

